import React from 'react';
import creditIcon32 from '../../assets/icons/credit-32x32.webp';
import creditIcon192 from '../../assets/icons/credit-192x192.webp';

/**
 * A reusable credit icon component.
 * Uses the 32x32 icon for small sizes and 192x192 for larger displays.
 * @param {Object} props
 * @param {'sm' | 'md' | 'lg' | 'xl'} props.size - Size variant of the icon
 * @param {string} props.className - Additional CSS classes
 */
const CreditIcon = ({ size = 'sm', className = '' }) => {
    const sizeClasses = {
        sm: 'w-4 h-4',
        md: 'w-5 h-5',
        lg: 'w-6 h-6',
        xl: 'w-8 h-8',
    };

    // Use larger icon for lg and xl sizes
    const iconSrc = size === 'lg' || size === 'xl' ? creditIcon192 : creditIcon32;

    return (
        <img
            src={iconSrc}
            alt="Credits"
            className={`${sizeClasses[size]} object-contain ${className}`}
        />
    );
};

export default CreditIcon;
